/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from 'react'
import './SingleSelect.scss'

const SingleSelect = props => {

    //int representing current selected option index
    const [selected, setSelected] = useState(-1);
    const [disabled, setDisabled] = useState(false);

    //feedback is obj representing current feedback text, gotten from data.options.feedback
    //null means no current feedback

    const data = props.data;
    // {
    //     questionText:"what is the answer?",
    //     options:[
    //         {
    //             "text":"whatever answer text",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text2",
    //             "correct":true,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text3",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         }
    //     ]
    // }


    const handleOptionClick = (optionIndex) => {
        if(selected === -1){
            setDisabled(true)
            setSelected(optionIndex)
            if(props.setCurrentChoice) props.setCurrentChoice(optionIndex)
            if(props.onChange) props.onChange(optionIndex)
        }
    }

    const handleCloseFeedback = () => {
        if(data.options[selected].correct){
            //correct
            props.onComplete("");
        }else{
            //incorrect
            setSelected(-1)
            if(props.onChange) props.onChange(-1)
            setDisabled(false)
        }
    }


    return (
        <div className={`SingleSelect ${data.class}`}>
            {/* <div className={`debug`}>
                Current: {selected}
            </div> */}
            {data.header && <div className={`header`} dangerouslySetInnerHTML={{__html:data.header}}></div>}
            {data.questionText && <div className={`question-text`} dangerouslySetInnerHTML={{__html:data.questionText}}></div>}

            <div className={`options`}>
                {
                    data.options.map((option, optionIndex) => {
                        return <div key={`option-${optionIndex}`} className={`option ${selected === optionIndex ? 'selected' : "not-selected"} ${disabled ? 'disabled': ''}`} onClick={()=>handleOptionClick(optionIndex)}>
                            <div className={`bullet ${selected === optionIndex ? 'selected' : "not-selected"}`}></div>
                            <div className={`text`} dangerouslySetInnerHTML={{__html:option.text}}></div>
                            {                               
                                selected === optionIndex &&  
                                //if has feedback
                                (option.feedback ?                
                                <div className={`feedback`}>
                                    <h1>{option.correct ? 'Correct.' : 'Not quite.'}</h1>
                                    <div className={`feedback-body`} dangerouslySetInnerHTML={{__html:option.feedback.body}}>
                                    </div>
                                    <div className={`feedback-button global-button`} onClick={handleCloseFeedback}>{option.correct ? 'Next' : 'Retry'}</div>
                                </div> 
                                //else
                                :                                 
                                props.onComplete())
                            }
                        </div>
                    })
                }
            </div>
            <div className="stanford_icon"></div>


        </div>
    )
}

export default SingleSelect